import React from 'react';
import { Section } from '../components/Section';
import { StartHere } from '../components/StartHere';
import { Atomizer } from '../components/home/Atomizer';
import { asset } from '../data/redesignAssets';
import { DEMO_URL } from '../data/links';
import { BRAND_ROWS, CHANGES, LIBRARY_SPLIT, LIBRARY_TOTAL, OWNERSHIP, SOURCES, TRUST, WHAT_IT_DOES, WHO_FOR } from '../data/home';
const TONE = {
  ink: 'var(--ink)',
  ink2: 'var(--ink-2)',
  amber: 'var(--amber)'
} as const;
export function Home() {
  return <>
      <Section n="01" label="Instruction governance" noTop contentClassName="hero-c" data-id="element-409" data-mp="24htrulnneyj5">
        <img className="swirl" src={asset('hero-swirl-home.svg')} alt="" width={432} height={446} style={{
        right: -129,
        top: 87
      }} data-id="element-410" data-mp="29f26ic9l8kfn" />
        <h1 className="h1" style={{
        maxWidth: 980
      }} data-id="element-411" data-mp="2dfm4fi1zjs2u">
          Your rules, your policies, your
          <br className="d" data-id="element-412" data-mp="3kv0jusbstsmo" /> know-how. Turned into instructions
          <br className="d" data-id="element-413" data-mp="3ovucfz06rvlw" /> your AI has to follow.
        </h1>
        <p className="lede" data-id="element-414" data-mp="30wjcmpo0ou4v">
          <span className="nowrap-d" data-id="element-415" data-mp="30vqda9re16wr">We take what your company already knows, your policies, your</span>
          <br className="d" data-id="element-416" data-mp="2vyq8s3a6sc7r" /> business rules, the judgment calls your best people make every day, and put it to work inside the platforms you
          already use. No rebuilding your workflow. Fewer mistakes, and better business outcomes.
        </p>
        <div className="btns" data-id="element-417" data-mp="2mzcyx9i5hlmi">
          <a className="btn btn-s" href={DEMO_URL} target="_blank" rel="noopener" data-id="element-418" data-mp="2hy714x9mv864">
            Book a demo
          </a>
          <a className="btn btn-o" href="#atomizer" data-id="element-419" data-mp="2d6fakmqh92fz">
            See it on a real document <span className="mono" data-id="element-420" data-mp="287cgtyfy6inb">↓</span>
          </a>
        </div>
      </Section>

      <section className="bleed sec-dk does" data-id="element-421" data-mp="239jan5en9on1">
        <div className="sec" style={{
        borderTop: 0
      }} data-id="element-422" data-mp="23alx914xp4x5">
          <div className="sec-m" data-id="element-423" data-mp="1z7xosuk4u00p">
            <div className="sec-n" data-id="element-424" data-mp="1z6weisaxxhk1">02</div>
            <div className="sec-l" data-id="element-425" data-mp="1u8cnwelejhlc">What it does</div>
          </div>
          <div className="does-g" data-id="element-426" data-mp="1u94l1tundndq">
            {WHAT_IT_DOES.map((t, i) => <div className="does-i" key={t} data-id="element-427" data-mp="1kjxqz8f7f7al" data-mpi={i}>
                <div className="n" data-id="element-428" data-mp="1omc8np75010a">{String(i + 1).padStart(2, '0')}</div>
                <div className="t" data-id="element-429" data-mp="1onn85ctjumll">{t}</div>
              </div>)}
          </div>
        </div>
      </section>

      <Section n="03" label="Instruction data" id="atomizer" data-id="element-430" data-mp="1flmeepxiyioo">
        <div className="hgroup" data-id="element-431" data-mp="1fm5vy5j9j526">
          <h2 className="h2" style={{
          maxWidth: 900
        }} data-id="element-432" data-mp="23b8ctb62otvm">
            The rules already exist.
            <br data-id="element-433" data-mp="23dkt7jw6mw6k" />
            They’re just not data yet.
          </h2>
          <p className="lede" data-id="element-434" data-mp="289s29ljvknsq">
            Your industry’s regulations, your policies, your best reviewer’s corrections, and the institutional knowledge nobody wrote
            down. Synthia turns all of it into instruction data: owned, versioned, portable, and yours.
          </p>
        </div>

        <Atomizer data-id="element-435" data-mp="2m8hzr2alwphm" />

        <div className="flow" data-id="element-436" data-mp="2m7zvbidsj4ym">
          <div data-id="element-437" data-mp="2r1b1rieoxjq0">
            {SOURCES.map(s => <div className="srow" key={s.name} data-id="element-438" data-mp="2r242a1n23czp">
                <div style={{
              display: 'flex',
              alignItems: 'baseline'
            }} data-id="element-439" data-mp="flagtdjt6zzk">
                  <span className="k" style={{
                color: TONE[s.tone]
              }} data-id="element-440" data-mp="amqx7jsou0ad">
                    {s.code}
                  </span>
                  <span className="n" data-id="element-441" data-mp="oenndiasq044">{s.name}</span>
                </div>
                <span className="d" data-id="element-442" data-mp="kcirse0seteu">{s.desc}</span>
              </div>)}
          </div>
          <div className="flow-arrow" aria-hidden="true" data-id="element-443" data-mp="3sscbt2ubun0n">
            <svg width="120" height="80" viewBox="0 0 120 80" fill="none" stroke="#d4d1cd" strokeWidth="1.5" strokeLinecap="round" data-id="element-444" data-mp="3ssvrse0f31c1">
              <path d="M8 12 C 60 12, 60 40, 112 40" data-id="element-445" data-mp="3nvls85jbd9ah" />
              <path d="M8 40 L 112 40" data-id="element-446" data-mp="5ofkn1b0dbog" />
              <path d="M8 68 C 60 68, 60 40, 112 40" data-id="element-447" data-mp="5l9ynuxoepwy" />
              <path d="M104 34 L 112 40 L 104 46" stroke="#1a1917" data-id="element-448" data-mp="nrxwrttbh01" />
            </svg>
          </div>
          <div className="libcard" data-id="element-449" data-mp="1h1i17wd3y18m">
            <div className="top" data-id="element-450" data-mp="1h4mdzi4n25aw">
              <span style={{
              letterSpacing: '.12em'
            }} data-id="element-451" data-mp="1c487w5mll5fi">YOUR LIBRARY</span>
              <span style={{
              letterSpacing: '.04em',
              color: 'var(--green)'
            }} data-id="element-452" data-mp="27dwlkqri3gyx">growing</span>
            </div>
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4
          }} data-id="element-453" data-mp="2ccpz2j6sf7z3">
              <div className="big" data-id="element-454" data-mp="2cesy1spx4bfy">{LIBRARY_TOTAL}</div>
              <div className="cap" data-id="element-455" data-mp="2hb9mko114rtk">governed instructions, each with an owner, a version, and a trigger</div>
            </div>
            <div className="q" data-id="element-456" data-mp="2mcgwasmqg12v">
              {LIBRARY_SPLIT.map(x => <div key={x.k} data-id="element-457" data-mp="2qbzgtnan6a56">
                  <div className="k" data-id="element-458" data-mp="2qao9jdhzmk9b">{x.k}</div>
                  <div className="v" data-id="element-459" data-mp="2vb2cwi8n9610">{x.v}</div>
                </div>)}
            </div>
            <div className="ft" data-id="element-460" data-mp="303lnd6c1bl1l">
              <span data-id="element-461" data-mp="303c5k6158k6z">stays inside your walls</span>
              <span style={{
              color: 'var(--line-2)'
            }} data-id="element-462" data-mp="3526n74ndk2pi">·</span>
              <span data-id="element-463" data-mp="353hs57sk3gi7">trains nothing but yours</span>
            </div>
          </div>
        </div>

        <div className="cols own" data-id="element-464" data-mp="39ynf89xp317v">
          {OWNERSHIP.map(c => <div className="col" key={c.t} data-id="element-465" data-mp="3e2v2e2oi893z">
              <div className="col-t" data-id="element-466" data-mp="12ezx45kfaqy1">{c.t}</div>
              <div className="col-b" data-id="element-467" data-mp="12frk4rzyfgcp">{c.b}</div>
            </div>)}
        </div>
      </Section>

      <Section n="04" label="Attention loss" className="gridpaper bleed loss" data-id="element-468" data-mp="ybtm6kmd8bl8">
        <p className="big" data-id="element-469" data-mp="tfcvbins7j4g">At high instruction density, the best frontier model missed nearly one in three instructions.</p>
        <p className="sub" data-id="element-470" data-mp="oh1nfdh1riov">It won’t tell you which. A wrong answer reads exactly like a right one.</p>
        <p className="cite" data-id="element-471" data-mp="1m2614fg138lb">
          <a href="https://arxiv.org/abs/2507.11538" target="_blank" rel="noopener" data-id="element-472" data-mp="1h3w3zzaqtxx2">
            IFScale, “How Many Instructions Can LLMs Follow at Once?”
          </a>{' '}
          · 68% adherence at high density
        </p>
      </Section>

      <Section n="05" label="What changes" className="changes" data-id="element-473" data-mp="17d1feoa0ym8g">
        <h2 className="h2" data-id="element-474" data-mp="24t6zp2d8l24c">Right the first time, with receipts.</h2>
        <div className="cols" data-id="element-475" data-mp="24vjonzhewcqw">
          {CHANGES.map((c, i) => <div className="col" key={c.t} data-id="element-476" data-mp="201yoq1w9d8p2" data-mpi={i}>
              <div className="num" data-id="element-477" data-mp="200xf81uw4u9g">{String(i + 1).padStart(2, '0')}</div>
              <div className="t" data-id="element-478" data-mp="3ubdwllx8dxys">{c.t}</div>
              <div className="b" data-id="element-479" data-mp="26jpzfkae6os">{c.b}</div>
            </div>)}
        </div>
      </Section>

      <Section n="06" label="Who it’s for" className="who" data-id="element-480" data-mp="3klaveyfyhdpd">
        <div className="hgroup" data-id="element-481" data-mp="3kiopf38pr699">
          <h2 className="h2" style={{
          maxWidth: 900
        }} data-id="element-482" data-mp="3pjm1qz71l62u">
            Regulated work. Real consequences.
          </h2>
          <p className="lede" data-id="element-483" data-mp="3ambtdypp4gbc">
            Ask an AI the capital of France and there’s nothing to govern. The moment it drafts the denial, answers the regulator, or
            releases the payment, its output stops describing your business and starts <strong data-id="element-484" data-mp="31nrllslobr1w">committing</strong> it.
          </p>
        </div>
        <div className="cols" style={{
        ['--n' as string]: 4
      }} data-id="element-485" data-mp="36m1hk5f82vok">
          {WHO_FOR.map(w => <div className="col" key={w.t} data-id="element-486" data-mp="zvlemfvozhu1">
              <div className="t" data-id="element-487" data-mp="zspk71j1zbac">{w.t}</div>
              <div className="b" data-id="element-488" data-mp="14slnsznu90pd">{w.b}</div>
              <div className="tag" data-id="element-489" data-mp="14rka0nffu03y">{w.tag}</div>
            </div>)}
        </div>
      </Section>

      <Section n="07" label="Proof" className="trust" data-id="element-490" data-mp="1ev7f84qu87kc">
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16
      }} data-id="element-491" data-mp="19zjuc1je20kn">
          <div className="eyebrow" data-id="element-492" data-mp="1nqf5jkhd0tre">WORKS WITH</div>
          <div data-id="element-493" data-mp="1nr6re3l5nd4h">
            {BRAND_ROWS.map((row, r) => <div className={`brands${r === 0 ? ' first' : ''}`} key={r} data-id="element-494" data-mp="1iy44geavv1x9" data-mpi={r}>
                {row.map(b => b.file ? <div className="brand" key={b.name} data-id="element-495" data-mp="1xq5znl20d6qy">
                      <img src={asset(b.file)} alt={b.hideName ? b.name : ''} style={b.tall ? {
                height: 34
              } : undefined} data-id="element-496" data-mp="1snx3kftu9okm" />
                      {!b.hideName && <span data-id="element-497" data-mp="26mnb6peab6n8">{b.name}</span>}
                    </div> : <div className="brand wm" key={b.name} data-id="element-498" data-mp="22nxna2vme6pc">
                      {b.name}
                    </div>)}
              </div>)}
          </div>
        </div>
        <div className="cols" data-id="element-499" data-mp="8bhmhhllfkrv">
          {TRUST.map(t => <div className="col" key={t.k} data-id="element-500" data-mp="wta5icfnj2z8">
              <div className="eyebrow" style={{
            fontSize: 12
          }} data-id="element-501" data-mp="11t6aadw6ayfu">
                {t.k}
              </div>
              <div className="t" data-id="element-502" data-mp="16k4rrgswe2ko">
                {t.t.split('\n').map((line, i) => <React.Fragment key={i} data-id="element-503" data-mp="1algkvwazd5xm" data-mpi={i}>
                    {i > 0 && <br data-id="element-504" data-mp="1ak6ln3se5rpe" />}
                    {line}
                  </React.Fragment>)}
              </div>
              <div className="b" data-id="element-505" data-mp="dxaastvahlby">{t.b}</div>
            </div>)}
        </div>
      </Section>

      <StartHere n="08" data-id="element-506" data-mp="iwej7iae3f18" />
    </>;
}